import React from 'react';
import { makeStyles, Box, BoxProps } from '@material-ui/core';
import clsx from 'clsx';
import { visuallyhidden } from '../../util/styles';

const useStyles = makeStyles({
    visuallyHidden: visuallyhidden,
});

export const VisuallyHidden: React.FunctionComponent<BoxProps> = props => {
    const classes = useStyles();
    const { className, ...boxProps } = props;
    return <Box className={clsx(classes.visuallyHidden, className)} {...boxProps} />;
};
